'use client';

import { useState } from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Stats from '@/components/Stats';
import Problems from '@/components/Problems';
import Features from '@/components/Features';
import Roles from '@/components/Roles';
import Integrations from '@/components/Integrations';
import Pricing from '@/components/Pricing';
import HowItWorks from '@/components/HowItWorks';
import Testimonials from '@/components/Testimonials';
import FAQ from '@/components/FAQ';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';
import RegistrationWizard from '@/components/registration/RegistrationWizard';

export default function Home() {
  const [wizardOpen, setWizardOpen] = useState(false);

  const openWizard = () => setWizardOpen(true);
  const closeWizard = () => setWizardOpen(false);

  return (
    <>
      <Header onOpenWizard={openWizard} />
      <main>
        <Hero onOpenWizard={openWizard} />
        <Stats />
        <Problems />
        <Features />
        <Roles />
        <Integrations />
        <Pricing />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      {wizardOpen && <RegistrationWizard onClose={closeWizard} />}
    </>
  );
}
